import AverageTimeChart from "./AverageTimeChart";
import KSchedulesTable from "kinnect-front/KYard/Schedule/KSchedulesTable";
import TimeChart from "./TimeChart";
import {
	VCard,
	VCol,
	VRow
} from "vuetify/lib";

export default {
	name: "KRentalPickupsCharts",

	props: {
		report: Object
	},

	render() {
		return <VRow class="k-charts" justify="center">
			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<TimeChart
					report={this.report}
				></TimeChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<AverageTimeChart
					report={this.report}
				></AverageTimeChart>
			</VCol>

			<VCol class="k-chart-wrapper d-print-none" cols={12}>
				<VCard outlined>
					<KSchedulesTable
						dense
						editLoadTime={false}
						hiddenCols={[ "actions", "age" ]}
						items={this.report.greaterThan24HoursSchedules}
					>
						<template slot="title">
							Rental Pickups That Took More Than 24 Hours
						</template>
					</KSchedulesTable>
				</VCard>
			</VCol>
		</VRow>;
	}
};
